import * as yup from 'yup';

// Copied from PersonalDetailsDE.schema.ts — keep in sync if the desktop rule changes.
const phoneNumberRegexDE = /^(0|(\+49)|0049)[0-9]{8,15}$/;

const isValidNumber = (value: string) => {
  const whitespaceRemoved = value.replace(/\(|\)|\s+|-|\//g, '');
  return phoneNumberRegexDE.test(whitespaceRemoved);
};

export const phoneSchema = yup.object().shape({
  phoneNumber: yup
    .string()
    .required('benötigt')
    .test('Is a valid number', 'ungültige Eingabe', (value) =>
      isValidNumber(value ?? ''),
    ),
});
